import { type FC } from "react";
import * as styles from "./styles.css";

export type ScoutButtonProps = {
  url: string;
  clientShopId?: string;
  gaAction: string;
  gaLabel: string;
  workCode: string;
};

export const ScoutButton: FC<ScoutButtonProps> = ({
  url,
  clientShopId,
  gaAction,
  gaLabel,
  workCode,
}) => (
  <li className={styles.buttonOuter}>
    <a
      className={`${styles.button} ga-click js-webhook`}
      href={url}
      data-client-shop-id={clientShopId}
      data-ga-action={gaAction}
      data-ga-label={gaLabel}
      data-code={workCode}
    >
      スカウトを受ける
    </a>
  </li>
);
